import axios from "axios";

//日志记录
const setLog = (baseURL, data) => {
  return axios({
    method: 'post',
    headers: {
      Authorization: JSON.parse(LocalStorage.getItem('obj')).authToken
    },
    baseURL,
    url: '/platform/baseFun/setLog?vdnId=' + JSON.parse(LocalStorage.getItem('obj')).vdnId,
    data
  }).then(res => {
    if(res.data){
      if(res.data.retCode == 1){
        //清除缓存里的日志
        LocalStorage.removeItem('logData')
      }
    }
  })
}

export default setLog


// WEBPACK FOOTER //
// ./src/http/log.js